import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { costCentersStateSelector } from '~/selectors';

import { CostCenter } from './types';

export const useAllCostCenters = (): {
  costCenters: CostCenter[];
  hasData: boolean;
  isLoading: boolean;
  failedToLoad: boolean;
} => {
  return useSelector((state: StoreState) => {
    return costCentersStateSelector(state);
  });
};
